import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'hotjar_config-initialized-action_unknown';

/**
 * Hotjar recording was successfully initialized.
 */
export function trackHotjarConfigInitialized(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
